import React from "react";
import { Box, Typography } from "@mui/material";
import notfoundImg from "../../assets/images/notfound.png";

function Nodatafound({ height, text, align }) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: align,
        alignItems: "center",
        width: "100%",
        height: height,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 0,
        }}
      >
        <img src={notfoundImg} alt="no data" width="150px" />
        <Typography sx={{ fontSize: "16px", fontWeight: 600 }}>
          {text}
        </Typography>
      </Box>
    </Box>
  );
}

export default Nodatafound;
